// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { get, map } from "lodash";
import { Form } from "semantic-ui-react";

// subComponents
import InfoBox from "../InfoBox";
import Field from "../Field";

const FieldCard = ({
	fieldData = {},
	isEditable = false,
	companyFieldsInputHandler = () => {},
	noSendQuestion,
	questionsLanguage,
	windowSize = {},
	disabledStyle = false,
	groupsToken,
	token,
}) => {
	const fieldListRender = () => {
		const fieldDataItems = get(fieldData, "items", []);

		const fieldList = map(fieldDataItems, (fieldDataItem, index) => {
			return (
				<Field
					key={index}
					fieldData={fieldDataItem}
					fieldCard={fieldData}
					isEditable={isEditable}
					companyFieldsInputHandler={companyFieldsInputHandler}
					noSendQuestion={noSendQuestion}
					questionsLanguage={questionsLanguage}
					disabledStyle={disabledStyle}
					groupsToken={groupsToken}
					token={token}
				/>
			);
		});
		return fieldList;
	};

	return (
		<InfoBox
			title={get(fieldData, "label", "")}
			toggleable
			defaultToggleOpen={windowSize.width > 1400 || get(fieldData, "isOpen", false)}
			disabled={disabledStyle}>
			<Form noValidate>{fieldListRender()}</Form>
		</InfoBox>
	);
};

FieldCard.propTypes = {
	fieldData: PropTypes.object,
	windowSize: PropTypes.object,
	isEditable: PropTypes.bool,
	noSendQuestion: PropTypes.bool,
	disabledStyle: PropTypes.bool,
	companyFieldsInputHandler: PropTypes.func,
	questionsLanguage: PropTypes.string,
	groupsToken: PropTypes.array,
	token: PropTypes.string,
};

export default FieldCard;
